import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { TOC } from '@ember/component/template-only'
import type { PhosphorIconName } from 'phosphor-icons'

interface Signature {
  Element: HTMLSpanElement
  Args: {
    icon: PhosphorIconName
    iconColorClass?: string
  }
}

export const PanelHeadingIcon: TOC<Signature> = <template>
  <span class="flex h-10 w-10 items-center justify-center rounded-full bg-white" ...attributes>
    <PhosphorIcon @icon={{@icon}} class="w-8 {{if @iconColorClass @iconColorClass}}" />
  </span>
</template>
